import type {Filter} from './../filtering/filter';
import type {Grouping, _Grouping} from './grouping';
import type {GroupingResult, _GroupingResult} from './grouping-result';

/**
 * Generated from com.dataiku.dip.eda.compute.grouping.SubsetGrouping
 */
export interface SubsetGrouping extends _Grouping {
    filter: Filter;

    // PolyJson type
    type: 'subset';
}

export namespace SubsetGrouping {
    export const type = 'subset';
}

/** @deprecated Use Grouping.isSubsetGrouping() */ export function isSubsetGrouping(toTest: Grouping): toTest is SubsetGrouping { return SubsetGrouping.type === toTest['type']; }

export namespace SubsetGrouping {
    /**
     * Generated from com.dataiku.dip.eda.compute.grouping.SubsetGrouping$SubsetGroupingResult
     */
    export interface SubsetGroupingResult extends _GroupingResult {
        filter: Filter;

        // PolyJson type
        type: 'subset';
    }

    export namespace SubsetGroupingResult {
        export const type = 'subset';
    }

    /** @deprecated Use GroupingResult.isSubsetGroupingResult() */ export function isSubsetGroupingResult(toTest: GroupingResult): toTest is SubsetGroupingResult { return SubsetGroupingResult.type === toTest['type']; }
}